import React from "react";
import { Route, Routes } from "react-router";

import BreedingValuesCatalogPage from "#/pages/breeding-values/BreedingValuesCatalogPage.jsx";
import BreedingValuesComparisonGeneticTrendPage from "#/pages/breeding-values/BreedingValuesComparisonGeneticTrendPage.jsx";
import BreedingValuesComparisonRankPage from "#/pages/breeding-values/BreedingValuesComparisonRankPage.jsx";
import BreedingValuesDataDownloadPage from "#/pages/breeding-values/BreedingValuesDataDownloadPage.jsx";
import BreedingValuesPage from "#/pages/breeding-values/BreedingValuesPage.jsx";
import BreedingValuesRankPage from "#/pages/breeding-values/BreedingValuesRankPage.jsx";

export default function BreedingValuesRoutes() {
  return (
    <Routes>
      <Route index element={<BreedingValuesPage />} />
      <Route path="catalog" element={<BreedingValuesCatalogPage />} />
      <Route path="rank" element={<BreedingValuesRankPage />} />
      <Route
        path="comparison-rang"
        element={<BreedingValuesComparisonRankPage />}
      />
      <Route
        path="genetic-trend"
        element={<BreedingValuesComparisonGeneticTrendPage />}
      />
      <Route path="download" element={<BreedingValuesDataDownloadPage />} />
    </Routes>
  );
}
